var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.85q-2.5 0-4.125-1.65t-1.625-4.1q0-2.5 1.625-4.15Q21.5 7.3 24 7.3t4.125 1.65q1.625 1.65 1.625 4.15 0 2.45-1.625 4.1Q26.5 18.85 24 18.85Zm0-1.55q1.8 0 3.025-1.225Q28.25 14.85 28.25 13.1q0-1.8-1.225-3.025Q25.8 8.85 24 8.85q-1.8 0-3.025 1.225Q19.75 11.3 19.75 13.1q0 1.75 1.225 2.975T24 17.3ZM10 39.9v-10q0-1.35.75-2.4.75-1.05 2-1.6 2.5-1.15 5.425-1.9T24 23.25q2.9 0 5.825.75 2.925.75 5.425 1.9 1.25.55 2 1.6t.75 2.4v7.25q0 1.15-.8 1.95t-1.95.8H20.5q-1.65 0-2.775-1.125T16.6 36.05q0-1.65 1.125-2.775T20.5 32.15h6.3L30 25.6q-1.5-.45-3.15-.65t-2.85-.2q-2.9 0-5.525.65-2.625.65-5.075 1.85-.8.4-1.325 1.125-.525.725-.525 1.525v10Zm10.5-1.5h3.25l2.3-4.7H20.5q-.95 0-1.65.675t-.7 1.675q0 .95.7 1.65t1.65.7Zm4.9 0h9.85q.5 0 .85-.35t.35-.9V29.9q0-.85-.55-1.55-.55-.7-1.35-1.1-.65-.35-1.45-.65l-1.6-.6ZM24 13.1Zm0 18.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.de039ee09606959ea9069c0b5ea47a3c.svg";
export { ForwardRef as ReactComponent };